import { render, staticRenderFns } from "./DnLayoutFooter.vue?vue&type=template&id=308a0214&scoped=true&"
import script from "./DnLayoutFooter.vue?vue&type=script&lang=js&"
export * from "./DnLayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./DnLayoutFooter.vue?vue&type=style&index=0&id=308a0214&lang=scss&scoped=true&"
import style1 from "./DnLayoutFooter.vue?vue&type=style&index=1&id=308a0214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a0214",
  null
  
)

export default component.exports